/*───────────────────────────────────────────────────────────────
 📄 File: hooks/sipPhone/sipConnectionUtils.ts
 🧩 Description:
    Utility to build RTCIceServer[] from SipPhoneConfig.
    Pure function — no React or SIP.js dependencies.
    Extracted from useSipPhone.ts.
────────────────────────────────────────────────────────────────*/

import { SipPhoneConfig } from './sipPhone.types';

/**
 * Builds the RTCIceServer array for SIP.js peerConnectionConfiguration.
 * Priority: configured STUN → configured TURN → Google STUN fallback.
 */
export function buildIceServers(config: SipPhoneConfig): RTCIceServer[] {
    const servers: RTCIceServer[] = [];

    if (config.stunServers) {
        config.stunServers.split(',').forEach((stun) => {
            const trimmed = stun.trim();
            if (trimmed) servers.push({ urls: trimmed });
        });
    }

    if (config.turnServer) {
        servers.push({
            urls: config.turnServer,
            username: config.turnUsername || '',
            credential: config.turnPassword || '',
        });
    }

    if (servers.length === 0) {
        servers.push({ urls: 'stun:stun.l.google.com:19302' });
    }

    return servers;
}
